import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './AuthScreen.css';


// Design: "UrbaniX Auth" 2b — on-brand split. Form on the right (RTL), a light
// branded panel on the left previewing a real product card.
export default function AuthScreen() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const isRegister = mode === 'register';

  const switchMode = () => {
    setMode(isRegister ? 'login' : 'register');
    setError('');
    setNotice('');
  };

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    setNotice('');
    setSubmitting(true);
    try {
      if (isRegister) await register(email.trim(), password, name.trim());
      else await login(email.trim(), password);
    } catch (err) {
      setError(err.message || 'הפעולה נכשלה. נסו שוב.');
      setSubmitting(false);
    }
  }

  return (
    <div className="auth2" dir="rtl">
      <div className="auth2-card">
      {/* Form — right */}
      <div className="auth2-form">
        <div className="auth2-logo"><span className="auth2-logo-word">UrbaniX</span><span className="auth2-logo-ai">.ai</span></div>

        <form className="auth2-mid" onSubmit={onSubmit}>
          <h1 className="auth2-title">{isRegister ? 'יצירת חשבון' : 'התחברות'}</h1>
          <p className="auth2-sub">
            {isRegister ? 'הקימו חשבון כדי להתחיל לנהל פרויקטים.' : 'התחברו כדי להמשיך לסביבת העבודה.'}
          </p>

          {error && <div className="auth2-error" role="alert"><i className="fi fi-rr-exclamation" /> {error}</div>}

          <div className="auth2-fields">
            {isRegister && (
              <div className="auth2-field">
                <label>שם מלא <span className="auth2-req">*</span></label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="דנה בר-לב" autoComplete="name" required />
              </div>
            )}
            <div className="auth2-field">
              <label>אימייל <span className="auth2-req">*</span></label>
              <input className="auth2-ltr" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@firm.co.il" autoComplete="email" required />
            </div>
            <div className="auth2-field">
              <label>סיסמה <span className="auth2-req">*</span></label>
              <input className="auth2-ltr" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={isRegister ? 'לפחות 8 תווים' : 'הזינו סיסמה'} autoComplete={isRegister ? 'new-password' : 'current-password'} required />
              {!isRegister && (
                <div className="auth2-forgot">
                  <button type="button" className="auth2-link" onClick={() => setNotice('איפוס סיסמה יתווסף בקרוב. בינתיים פנו למנהל המערכת.')}>שכחתם סיסמה?</button>
                </div>
              )}
            </div>

            {notice && <p className="auth2-notice">{notice}</p>}

            <button type="submit" className="auth2-cta" disabled={submitting}>
              {submitting ? 'רגע…' : isRegister ? 'יצירת חשבון' : 'התחברות'}
            </button>
          </div>
        </form>

        <div className="auth2-prompt">
          {isRegister ? 'כבר יש לכם חשבון?' : 'עדיין אין לכם חשבון?'}{' '}
          <button type="button" className="auth2-link auth2-link-strong" onClick={switchMode}>{isRegister ? 'התחברות' : 'יצירת חשבון'}</button>
        </div>
      </div>

      {/* Branded panel — left */}
      <div className="auth2-brand">
        <svg className="auth2-grid" viewBox="0 0 400 300" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <pattern id="ux2grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M40 0H0V40" fill="none" stroke="rgba(46,124,168,0.12)" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="400" height="300" fill="url(#ux2grid)" />
        </svg>

        <div className="auth2-brand-text">
          <h2>ניתוח זכויות בנייה,<br /><span>מקצה לקצה.</span></h2>
          <p>איסוף המצב הסטטוטורי, ניהול בעלי עניין ובניית ניתוח הזכויות — במקום אחד, משותף לכל המשרד.</p>
        </div>

        <div className="auth2-preview" aria-hidden="true">
          <div className="auth2-preview-top">
            <div className="auth2-preview-id">
              <span className="auth2-preview-badge">27</span>
              <span className="auth2-preview-name">מגרש 27</span>
            </div>
            <span className="auth2-preview-status"><span className="auth2-preview-dot" />מאושר</span>
          </div>
          <div className="auth2-preview-div" />
          <div className="auth2-preview-stats">
            <div>
              <div className="auth2-preview-k">זכויות בנייה</div>
              <div className="auth2-preview-v">4,210 <span>מ"ר</span></div>
            </div>
            <div>
              <div className="auth2-preview-k">אחוז בנייה</div>
              <div className="auth2-preview-v">180%</div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
